var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38368",
    "data-name": "Group 38368",
    transform: "translate(-1230 -7771)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7804",
    "data-name": "Rectangle 7804",
    width: 16,
    height: 16,
    transform: "translate(1230 7771)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_01_align_center",
    "data-name": "01 align center",
    transform: "translate(1234.447 7772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16640",
    "data-name": "Path 16640",
    d: "M6.281,0l.824.824L1.337,6.593a.584.584,0,0,0,0,.825L7.1,13.175,6.27,14,.513,8.244a1.751,1.751,0,0,1,0-2.476Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.2d67985bd04677fb6ed38b7c654bc5cb.svg";
export { ForwardRef as ReactComponent };